import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router'
import { PaginatedList } from 'Layout'

import { _Container, _ListCount, _AddressList, _Address, _ListingList, _Listing, _Offer } from './styles'

const PaginatedAddressList = (props) => {
  const { addresses, addressPagination, location, areaName } = props
  const addressList = addresses && addresses.data
  return (
    <_Container>
      <h2>Addresses <_ListCount>{addresses.total}</_ListCount></h2>
      {
        addresses &&
          <PaginatedList
            pagination={addressPagination}
            location={location}
          >
            {
              addressList && addressList.length ?
                <_AddressList>
                  {
                    addressList.map(address => {
                      const Elem = address.url ? Link : 'div'
                      return (
                        <_Address key={address.id}>
                          {
                            address.listings && address.listings.length ?
                              <Fragment>
                                {address.street_number} {address.street_name}
                                <_ListingList>
                                  {
                                    address.listings.map(listing => {
                                      const ListingElem = listing.url ? Link : 'div'
                                      return (
                                        <_Listing key={listing.id}>
                                          <ListingElem to={`/${listing.url}`}>
                                            {listing.title} <_Offer>{listing.offer}</_Offer>
                                          </ListingElem>
                                        </_Listing>
                                      )
                                    })
                                  }
                                </_ListingList>
                              </Fragment>
                              :
                              <Elem to={`/${address.url}`}>
                                {address.street_number} {address.street_name}
                              </Elem>
                          }
                        </_Address>
                      )
                    })
                  }
                </_AddressList> :
                addressList && !addressList.length ?
                  <span>Currently there is no address in {areaName}</span>
                  : null
            }
          </PaginatedList>
      }
    </_Container>
  )
}


PaginatedAddressList.propTypes = {
  addresses: PropTypes.shape({
    per_page: PropTypes.number,
    total: PropTypes.number,
    current_page: PropTypes.number,
    data: PropTypes.shape({}),
    area_stats: PropTypes.shape({}),
  }),
  areaName: PropTypes.string,
  location: PropTypes.shape({
    search: PropTypes.string,
  }),
  addressPagination: PropTypes.shape({}),
}

export default PaginatedAddressList
